
    <!-- =================================== Reusable  Feedback Form  (Employee, Manager) =============================================================== -->
    
    <div class="feedback-form">
      <h2 class="form-title">
        <span>Feedback Form</span>
      </h2>
          
      <div *ngFor="let q of questions" class="question-block">
        <div class="question-text">{{ q.id }}. {{ q.question }}</div>
    
        <div class="stars-wrapper">
          <div
            *ngFor="let rating of q.ratings"
            class="star-box"
            [ngClass]="{ 'active': q.selected === rating.value }"
            (click)="q.selected = rating.value"
          >
            <svg class="star-icon" viewBox="0 0 24 24">
              <path
                d="M12 .587l3.668 7.429 8.2 1.193-5.934 5.782 1.4 8.166L12 18.896l-7.334 3.861 1.4-8.166L.132 9.209l8.2-1.193z"
              />
            </svg>
            <div class="star-number">{{ rating.value }}</div>
            <span class="rating-label">{{ rating.label }}</span>
          </div>
        </div>
      </div>
    
      <div class="submit-area">
        <button class="submit-btn" (click)="submitRatings()"> Submit</button>
       
      </div>
      <div class="submitted-info">✅ Submitted on 10-05-2025 | 11:17 AM</div>
    </div>

    